// extracted by mini-css-extract-plugin
module.exports = {"Notification":"Notification_Notification__1qOgX","Success":"Notification_Success__2IdvR","Fail":"Notification_Fail__1uHJn"};